import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'

export const SuccessDialog = ({ open, onOk }) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <div>ลงทะเบียนสำเร็จแล้ว เราจะทำการติดต่อท่านกลับไปในไม่ช้า</div>
        <div>Register successfully . We will contact you soon</div>
      </DialogTitle>
      <DialogActions>
        <Button onClick={onOk} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

SuccessDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired
}

export default SuccessDialog



// WEBPACK FOOTER //
// ./src/pages/Location/components/SuccessDialog/index.js